<template>
    <!--
        <upload-images
            v-model="fileList"
            multiple
            :limit="2"
            >
        </upload-images>
    -->

    <div class="upload">
        <el-upload
            :class="{'hide':imgLength >= limit}"
            :disabled="disabled"
            :multiple="multiple"
            :action="action"
            :limit="limit"
			name="imgUpload"
            :list-type="listType"
            :show-file-list="showFileList"
            :before-upload="beforeAvatarUpload"
            :on-success="handleSuccess"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-change="handlePictureChange"
            :on-exceed="handleExceed"
            :on-remove="handleRemove">
            <div slot="trigger">
                <slot><i class="el-icon-plus"></i></slot>
            </div>
        </el-upload>
        <el-dialog width="800px" :visible.sync="dialogVisible" append-to-body>
            <img class="dialogImage" :src="dialogImageUrl">
        </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            start:true,
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
            propList: [],
            imgLength: 0,
            loading: false,
            disabled: false,
        }
    },
    props: {
        value: {
            // type: Array,
            default: []
        },
        multiple: {
            type: Boolean,
            default: false
        },
        one: {
            type: Boolean,
            default: false
        },
        showFileList: {
            type: Boolean,
            default: true
        },
        string: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 20
        },
        size: {
            type: Number,
            default: 2
        },
        action: {
            type: String,
            default: process.env.VUE_APP_FILE_BASE_URL || ''
        },
        listType: {
            type: String,
            default: 'picture-card'
        },
        target: {
            type: String,
            default: process.env.VUE_APP_FILEAPI_BASE_URL || ''
        },
    },
    methods: {
        handlePictureChange(file, fileList) {
			this.$emit('gaibian', true)
            this.imgLength = fileList.length
            if(this.one && !this.loading){
                this.$emit('change', true)
                this.disabled = true
            }
        },
        handleSuccess(file, fileInfo){
            this.start = false
            if(this.one){
                this.propList = []
                this.$emit('change', false)
                this.disabled = false
                this.loading = true
                setTimeout(() => {
                    this.loading = false
                },300)
            }
            let item = this.target + file.imgPath
            if(this.showFileList && this.listType == 'text'){
                item = { url: this.target + file.imgPath, name: fileInfo.name }
            }
            this.propList.push(item)
            let val = [...this.propList]
            if(this.string){
                val = val.join(',')
            }
            this.$emit('input',val)
        },
        handleRemove(file, fileList){
			
            let url = file.response ? file.response.imgPath : file.url
            setTimeout(() => {
                this.imgLength = this.propList.length
            },500)
            this.propList.forEach((item, index) => {
                if(this.showFileList && this.listType == 'text'){
                    item = item.url
                }
                if(item.indexOf(url) > -1){
                    this.propList.splice(index,1)
                    let val = [...this.propList]
                    if(this.string){
                        val = val.join(',')
                    }
                    this.$emit('input',val)
                }
            })
			this.$emit('gaibian', true)
        },
        handleExceed(a,b){
            this.$message.error('最多上传'+ this.limit +'个文件')
        },
        handlePictureCardPreview(file){
            if(this.showFileList && this.listType == 'picture-card'){
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        },
        beforeAvatarUpload(file){
            const isLtSize = file.size / 1024 / 1024 < this.size
            if (!isLtSize) {
                this.$message.error('文件大小不能超过 '+ this.size +'M')
            }
            return isLtSize
        }
    },
    watch:{
        value: function(list){
            if(!list.length){
                this.propList = []
                this.fileList = []
                this.imgLength = 0
            }
            if(this.start){
                this.start = false
                if(this.string){
                    list = list.split(',')
                }
                this.propList = [...list]
                this.imgLength = list.length
                list.forEach((url,index) => {
                    let item = { url }
                    if(this.showFileList && this.listType == 'text'){
                        item = { url: url.url, name: url.name }
                    }
                    this.fileList.push(item)
                })
            }
        }
    }
}
</script>

<style scoped>
    .hide >>> .el-upload{display: none;}
    .dialogImage{display: block;max-width: 100%;max-height: 500px;margin: auto;}
</style>